import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'
import { textru } from './textru'

export const statistic = {
  textru,
  fetchStatisticViews: lazyModuleMethod(
    () => import('./fetchStatisticViews'),
    'default'
  ),
  fetchStatisticTotal: lazyModuleMethod(
    () => import('./fetchStatisticTotal'),
    'default'
  ),
  fetchStatisticAuthors: lazyModuleMethod(
    () => import('./fetchStatisticAuthors'),
    'default'
  ),
  fetchStatistics: lazyModuleMethod(
    () => import('./fetchStatistics'),
    'default'
  ),
  fetchStatisticSeo: lazyModuleMethod(
    () => import('./fetchStatisticSeo'),
    'default'
  ),
  fetchArticleStatTotalViews: lazyModuleMethod(
    () => import('./fetchArticleStatTotalViews'),
    'default'
  ),
  fetchStatisticArticleAllViews: lazyModuleMethod(
    () => import('./fetchStatisticArticleAllViews'),
    'default'
  ),
  fetchStatisticArticleSearchViews: lazyModuleMethod(
    () => import('./fetchStatisticArticleSearchViews'),
    'default'
  ),
  exportStatisticArticleSearchViews: lazyModuleMethod(
    () => import('./exportStatisticArticleSearchViews'),
    'default'
  ),
  fetchStatisticCountContent: lazyModuleMethod(
    () => import('./fetchStatisticCountContent'),
    'default'
  ),
  fetchStatisticViewsContent: lazyModuleMethod(
    () => import('./fetchStatisticViewsContent'),
    'default'
  ),
  fetchStatisticMaterialGroup: lazyModuleMethod(
    () => import('./fetchStatisticMaterialGroup'),
    'default'
  ),
  fetchStatisticUsersCount: lazyModuleMethod(
    () => import('./fetchStatisticUsersCount'),
    'default'
  ),
  fetchStatisticViewsCount: lazyModuleMethod(
    () => import('./fetchStatisticViewsCount'),
    'default'
  ),
  fetchStatisticMedian: lazyModuleMethod(
    () => import('./fetchStatisticMedian'),
    'default'
  ),
  fetchStatisticTrafficSource: lazyModuleMethod(
    () => import('./fetchStatisticTrafficSource'),
    'default'
  ),
  fetchStatisticTrafficSourceViews: lazyModuleMethod(
    () => import('./fetchStatisticTrafficSourceViews'),
    'default'
  ),
  fetchStatisticTrafficSourceMeta: lazyModuleMethod(
    () => import('./fetchStatisticTrafficSourceMeta'),
    'default'
  ),
  fetchAllViewsByDays: lazyModuleMethod(
    () => import('./fetchAllViewsByDays'),
    'default'
  ),
}
